export const GTMOpenSizeGuide = (
  section: 'SectionProductConversionArea' | 'SectionTechnicalSpecifications',
) => {
  const w = window as any

  w.dataLayer = w.dataLayer || []
  w.dataLayer.push({ event: 'open_size_guide', size_guide: { section } })
}
